import '@webcomponents/webcomponentsjs/webcomponents-sd-ce.js';
import 'babel-polyfill';
import 'intl';
import 'intl/locale-data/jsonp/en-US';
import 'intl/locale-data/jsonp/fr-CA';
import 'intl/locale-data/jsonp/es-MX.js';
import URLSearchParams from 'url-search-params';

import {checkPrintableRoute} from './util/printableRoutes.js';

import React from 'react';
import ReactDOM from 'react-dom';
import qwest from 'qwest';

import 'util/configureQwest';
import hopscotch from 'hopscotch';
import 'autotrack';
import 'lib/ga';

import {getPrivacyPolicy, getTermsOfUse} from 'api/info';
import events from 'lib/events';
import IntlWrapper from 'components/layout/intlWrapper';
import session from 'services/sessionService';
import Layout from 'layout/container';
import Printable from 'layout/printable';

import 'components/tools/databaseExport.jsx';
import 'components/tools/databaseUpload.jsx';
import 'components/tools/databaseUploadEmail.jsx';
import 'page/analysis/report.jsx';
import 'page/analysis/reportHistory.jsx';
import 'page/analysis/scanning2p0.jsx';
import 'page/customer/edit.jsx';
import 'page/customer/mergeSystems';
import 'page/customer/notes.jsx';
import 'page/customer/seasonUsage.jsx';
import 'page/customer/system/main2p0.jsx';
import 'page/customer/view.jsx';
import 'page/encyclopedia/encyclopedia.jsx';
import 'page/encyclopedia/encyclopedia.jsx';
import 'page/notifications.jsx';
import 'page/posDashboard.jsx';
import 'page/privacyPolicy.jsx';
import 'page/reports/bioguard/main.jsx';
import 'page/reports/communications/main.jsx';
import 'page/reports/customer/main.jsx';
import 'page/reports/followups/main.jsx';
import 'page/reports/landingPage.jsx';
import 'page/reports/water/main.jsx';
// import 'page/reports/water/TrublueClaims/OpenClaim/claim.jsx';
import 'page/search/main.jsx';
import 'page/settings/settings.jsx';
import 'page/signIn.jsx';
import 'page/signOut.jsx';
import 'page/termsOfService.jsx';
import 'page/tools/QuickCalcs/inner';
import 'page/tools/Accounts/FindReplace';
import 'page/tools/Accounts/Inactive.jsx';
import 'page/tools/Accounts/Merge';
import 'page/tools/Accounts/Merge/Merge';
import 'page/tools/Accounts/MultipleSystems';
import 'page/tools/Accounts/SplitContacts';
import 'page/tools/Accounts/VerifyAddresses';
import 'page/tools/calibration2p0.jsx';
import 'page/tools/tools.jsx';
import 'page/tools/trashBin.jsx';

window.URLSearchParams = window.URLSearchParams || URLSearchParams;

window.addEventListener('storage', function(e) {
  console.debug(e);
}, false);

let bodyHiddenFromPrint = false;

document.addEventListener('DOMContentLoaded', (e) => {
  console.groupCollapsed('Rendering initial layout');
  console.log(e);
  ReactDOM.render(
    <IntlWrapper>
      <Layout />
    </IntlWrapper>,
        document.getElementById('body'));
  ReactDOM.render(<Printable />, document.getElementById('printable'));
  console.groupEnd();

  // Inital check if on printable page
  let loc = window.location.hash;

  if (loc.charAt(0) === '#') {
    loc = loc.substr(1);
  }
  bodyHiddenFromPrint = !checkPrintableRoute(loc);
  // Keep alive for infinite sessions
  var ka = () => {
    qwest.getOnline('https://alexflash.azureedge.net/msg/message.json').then(
      (res, data) => {
        if (data && data.message && data.message !== '') {
          events.publish('siteerror.error', data.message);
        } else {
          events.publish('siteerror.success', true);
        }
      }
    );
  };

  window.keepAliveInterval = setInterval(ka, 30000);
  window.keepAliveTimeout = setTimeout(ka, 1000);

  // Polyfill to add oldURL on hashchange event for ie
  if(!window.HashChangeEvent) {
    (function() {
      var lastURL = document.URL;

      window.addEventListener('hashchange',function(event) {
        Object.defineProperty(event,'oldURL',{enumerable: true,configurable: true,value: lastURL});
        Object.defineProperty(event,'newURL',{enumerable: true,configurable: true,value: document.URL});
        lastURL = document.URL;
      });
    }());
  }

  // Load up the hashchange event
  window.onhashchange = (e) => {
    let loc = window.location.hash;

    if (loc.charAt(0) === '#') {
      loc = loc.substr(1);
    }
    //Overide Bootstrap hidden-print class on id='body'
    bodyHiddenFromPrint = !checkPrintableRoute(loc);

    var systemPage = /customer\/([0-9]+)\/([0-9]+)/;

    if (e.oldURL.match(systemPage) && !e.newURL.match(systemPage)) {
      let res = e.oldURL.match(systemPage);

      session.removeEdittingTests(res[2]);

      setTimeout(() => {
        session.forgetAnalysisIfManual(res[2]);
      }, 100); // Need to set timeout since if leave directly from the analysis page it sets in state after the hashchange event
    }

    events.publish('hashchange', loc);
    // This should probably be fixed at some point to exist on each page instead of excluding the 2 pages liek we're doing here
    if(!loc.includes('privacy-policy') && !loc.includes('terms-of-service')) {
      document.querySelector('body').scrollTop = 0;
    }
    events.publish('ga.page', {location: '/' + loc});

    window.appInsights.trackPageView();
  };

  // global click event (for click-aways)
  window.onclick = (e) => {
    let clickX = 0;
    let clickY = 0;

    if (e.pageX || e.pageY) {
      clickX = e.pageX;
      clickY = e.pageY;
    } else if ((e.clientX || e.clientY) &&
       document.compatMode === 'CSS1Compat' &&
       document.documentElement &&
       document.documentElement.scrollLeft !== null) {
      clickX = e.clientX + document.documentElement.scrollLeft;
      clickY = e.clientY + document.documentElement.scrollTop;
    } else if ((e.clientX || e.clientY) &&
       document.body &&
       document.body.scrollLeft !== null) {
      clickX = e.clientX + document.body.scrollLeft;
      clickY = e.clientY + document.body.scrollTop;
    }

    let loc = {
      pageX: clickX,
      pageY: clickY,
      clientX: e.clientX,
      clientY: e.clientY,
      screenX: e.screenX,
      screenY: e.screenY,
    };

    events.publish('click', loc);
  };

  let uiInitiatedPrint = false;

  events.subscribe('print', () => uiInitiatedPrint = true);

  const beforePrint = () => {
    if (!uiInitiatedPrint && bodyHiddenFromPrint) {
      const bodyElement = document.getElementById('body');
      bodyElement.classList.remove('hidden-print');
    }

    if (uiInitiatedPrint){
      const bodyElement = document.getElementById('body');
      bodyElement.classList.add('ui-initiated-print');
    }
  
  };
  const afterPrint = () => {
    events.publish('afterPrint');

    if (uiInitiatedPrint){
      const bodyElement = document.getElementById('body');
      bodyElement.classList.remove('ui-initiated-print');
    }
    uiInitiatedPrint = false;

    // If we removed the hidden-print class from the body element,
    // have the element readded if we're on a normally printable route.
    let loc = window.location.hash;

    if (loc.charAt(0) === '#') {
      loc = loc.substr(1);
    }
    //Overide Bootstrap hidden-print class on id='body'
    bodyHiddenFromPrint = !checkPrintableRoute(loc);
  };

  // Need both matchmedia and onbefore/after listeners for full browser support
  if (window.matchMedia) {
    const mediaQueryList = window.matchMedia('print');

    mediaQueryList.addListener((mql) => {
      if (mql.matches) {
        beforePrint();
      } else {
        afterPrint();
      }
    });
  }

  window.onbeforeprint = beforePrint;
  window.onafterprint = afterPrint;
});

/**
* Number.prototype.format(n, x)
*
* @param {Number} n: integer length of decimal
* @param {Number} x: integer length of sections
* @returns {String} Returns the number formatted with n decimal places and a comma every x digits before the decimal
*/
// eslint-disable-next-line no-extend-native
Number.prototype.format = function(n, x) {
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';

  return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};

if (Array.prototype.equals) {
  console.warn('Overriding existing Array.prototype.equals.');
}

/**
 * Returns if two arrays are equal
 * Deeply compares inner arrays but not inner objects or other types
 * @param {Array} array: the array to be compared
 * @returns {Boolean} if the two arrays are equal
 */
// eslint-disable-next-line no-extend-native
Array.prototype.equals = function(array) {
  if (!array) {
    return false;
  }

  if (this.length !== array.length) {
    return false;
  }

  for (var i = 0, length = this.length; i < length; i++) {
    if (this[i] instanceof Array && array[i] instanceof Array) {
      if (!this[i].equals(array[i])) {
        return false;
      }
    } else if (this[i] !== array[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
};

/*
 * Paginate an array
 * @param {Array} array: the array to be paginated
 * @returns {Array} A new array of these chunks.
 */
// eslint-disable-next-line no-extend-native
Array.prototype.paginate = function(groupsize) {
  var sets = [];
  var chunks = this.length / groupsize;

  for (var i = 0, j = 0; i < chunks; i++, j += groupsize) {
    sets[i] = this.slice(j, j + groupsize);
  }

  return sets;
};


// Element closest polyfill for IE11
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;

    if (!document.documentElement.contains(el)) {return null;}
    do {
      if (el.matches(s)) {return el;}
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}